import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ChartOptions, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';
import { Subscription } from 'rxjs';
import { DiaryModalComponent } from 'src/app/modal/diary-modal/diary-modal.component';
import { ViewInvoiceModalComponent } from 'src/app/modal/view-invoice-modal/view-invoice-modal.component';
import { AuthService } from 'src/app/service/auth/auth.service';
import { HomeService } from 'src/app/service/common/home.service';
import { Permission, UserType } from 'src/app/service/common/interface';
import { InvoiceService } from 'src/app/service/pages/invoice.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  home : any;
  private _subs : Subscription = new Subscription();
  barristerInvoices : any;
  solicitorInvoices : any;
  userType : UserType = null;
  barristerId : any = null;
  baseUrl : any;
  permission : Permission;
  constructor(
    private homeService : HomeService,
    private invoiceService : InvoiceService,
    private dialog : MatDialog,
    private auth : AuthService,
  ) {
    this.barristerId = 'all';
    this.baseUrl = environment.root;
    if(this.auth.getUserType()){
      this.auth.getUserType().subscribe(res=>{
        this.userType = res;
        if(this.userType.userTypeId){
          if(this.userType.userTypeId == 2){
            this.barristerId = this.userType.barristerId;
          }else{
            this.barristerId = 'all';
            this.loadInvoices();
          }
          this.loadDiary();
        }
      })
    }
  }

  public pieChartOptions: ChartOptions = {
    responsive: true,
  };
  public pieChartLabels: Label[] = [];
  public pieChartData: any[];
  public colors: any[];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];


  public barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartLabels = [];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartData = [];


  ngOnInit() {
    this.auth.getPermission().subscribe(res => {
      this.permission = res;
    })
  }

  loadDiary(){
    this._subs.add(
      this.homeService.getCounts(this.barristerId).subscribe(res => {
        // console.log(res);
        this.home = res.data;
        this.barChartLabels = this.home.chartData.months;
        this.barChartData = [
          { data : this.home.chartData.totalCases, label: 'Total Cases', backgroundColor : '#05A330'},
          { data : this.home.chartData.totalFees, label: 'Total Fees', backgroundColor : '#FFC300'},
          { data : this.home.chartData.totalPayments, label: 'Total Payment Made', backgroundColor : '#05A330'},
        ]
        
        this.pieChartLabels = this.home.pieLabel;
        this.pieChartData = this.home.pieData;

        this.colors = [
          {
            backgroundColor: 
            ["#ADD8E6", "#8B0000", "#ffb6c1", "#AA336A","#808080", "#00FF00", "#FFA500", "#90ee90" ]
          }, //private
  
        ];
        this.pieChartLabels = this.home.pieLabel;
        this.pieChartData = this.home.pieData;
        // this.pieChartColors = colors;

      })
    )
  }

  loadInvoices(){
    this._subs.add(
      this.invoiceService.getInvoices('solicitor', 'all', 'all', 'all', 'all', '0', 'all', '10', 'dueDate').subscribe(res => {
        // console.log(res);
        if(res.status == 'ok'){
          this.solicitorInvoices = res.data;
        }else{
          this.solicitorInvoices = null;
        }
      })
    )
  }

  openModal(type){
    // console.log(type);
    const config : MatDialogConfig = {
      width : "1200px",
      data : {
        'type' : type,
        'barristerId' : this.barristerId
      }
    };
    this.dialog.open(DiaryModalComponent, config);
  }

  viewInvoice(id, caseId){
    let config : MatDialogConfig = {
      width : "1050px",
      data : {
        'tableName' : 'solicitor',
        'id' : id,
        'caseId' : caseId
      }
    }
    this._subs.add(
      this.dialog.open(ViewInvoiceModalComponent, config).afterClosed().subscribe(res => {
        if(res){
          this.loadInvoices();
        }
      })
    )
  }


}
